(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bagly-newsletter-popup"]) return;
  try {
    
  if (!customElements.get('bagly-newsletter')) {
    customElements.define('bagly-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const dialog = this.querySelector('dialog');
        const opener = this.querySelector('[data-newsletter-open]');
        const seenKey = 'bagly-newsletter-seen-v1';
        const subscribedKey = 'bagly-newsletter-subscribed-v1';
        const remember = (key) => {
          try { localStorage.setItem(key, '1'); return true; } catch { return false; }
        };
        const open = () => {
          if (!dialog.open) dialog.showModal();
          remember(seenKey);
        };
        opener.addEventListener('click', open);
        this.querySelector('[data-newsletter-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => {
          if (!opener.hidden) opener.focus();
        });
        const initialize = () => {
          if (!this.isConnected || this.dataset.designMode === 'true' || window.Shopify?.designMode) return;
          const popupSuccess = this.querySelector('[data-newsletter-success]');
          if (popupSuccess || document.querySelector('[data-newsletter-footer-success]')) {
            remember(subscribedKey);
            remember(seenKey);
            opener.hidden = true;
            if (popupSuccess) open();
            return;
          }
          const formContent = this.querySelector('[data-newsletter-form-content]');
          const existingSubscription = this.querySelector('[data-newsletter-existing]');
          const formWasSubmitted = new URLSearchParams(window.location.search).get('form_type') === 'customer';
          if (existingSubscription && formContent?.dataset.returnedEmail && formWasSubmitted && !this.querySelector('[data-newsletter-error]')) {
            formContent.hidden = true;
            existingSubscription.hidden = false;
            remember(subscribedKey);
            remember(seenKey);
            opener.hidden = true;
            open();
            return;
          }
          if (this.querySelector('[data-newsletter-error]')) { open(); return; }
          try {
            if (localStorage.getItem(subscribedKey)) { opener.hidden = true; return; }
            if (localStorage.getItem(seenKey)) return;
            if (remember(seenKey)) open();
          } catch {}
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
        else initialize();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const scrollButton = event.target.closest('.footer-scroll-top');
    if (scrollButton) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  if (!customElements.get('bagly-cookie-preferences')) {
    customElements.define('bagly-cookie-preferences', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const reveal = () => { this.hidden = typeof window.privacyBanner?.showPreferences !== 'function'; };
        reveal();
        window.addEventListener('load', reveal, { once: true });
        this.querySelector('button').addEventListener('click', async () => {
          const status = this.querySelector('[role=status]');
          status.hidden = true;
          try { await window.privacyBanner.showPreferences(); }
          catch { status.hidden = false; }
        });
      }
    });
  }

  if (!customElements.get('bagly-legal-draft-dialog')) {
    customElements.define('bagly-legal-draft-dialog', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        const dialog = this.querySelector('dialog');
        const content = this.querySelector('[data-bagly-legal-dialog-content]');
        const closeButton = this.querySelector('[data-bagly-legal-dialog-close]');
        const preview = document.querySelector('[data-bagly-legal-preview]');
        const allowedHandles = new Set([
          'informazioni-legali',
          'resi-e-recesso',
          'privacy-policy',
          'cookie-policy',
          'termini-e-condizioni',
        ]);
        let opener;

        if (!dialog || !content || !closeButton || !preview) return;

        const handleFromLink = (link) => {
          const url = new URL(link.href, window.location.href);
          const match = url.pathname.match(/\/pages\/([^/]+)\/?$/);
          return match && allowedHandles.has(match[1]) ? match[1] : null;
        };

        const showPolicy = (handle, link) => {
          const template = preview.querySelector(`template[data-bagly-legal-handle="${handle}"]`);
          if (!template?.content.querySelector('article')) return;

          opener = link;
          content.replaceChildren(template.content.cloneNode(true));
          const heading = content.querySelector('h1');
          if (heading) heading.id = 'BaglyLegalDraftDialogTitle';
          dialog.scrollTop = 0;
          if (!dialog.open) dialog.showModal();
        };

        document.addEventListener('click', (event) => {
          const link = event.target.closest('footer a[href]');
          if (!link) return;
          const handle = handleFromLink(link);
          if (!handle) return;
          event.preventDefault();
          showPolicy(handle, link);
        });

        closeButton.addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => opener?.focus());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
